/**
 * Cookie consent. Only strictly necessary cookies are set by default; analytics (Google Analytics,
 * G-4VVGTP7H1B) loads only after the visitor accepts it. The choice is stored per browser.
 */
export interface CookieConsent {
  necessary: true;
  analytics: boolean;
  marketing: boolean;
  savedAt: string;
  version: 1;
}

const KEY = 'endeeko.cookieConsent';
const GA_ID = 'G-4VVGTP7H1B';
export const OPEN_COOKIE_SETTINGS_EVENT = 'open-cookie-settings';
export const COOKIE_CONSENT_CHANGED_EVENT = 'cookie-consent-changed';

let analyticsLoaded = false;

/** Loads Google Analytics once. Called only after consent. */
function loadAnalytics() {
  if (analyticsLoaded) return;
  analyticsLoaded = true;
  const w = window as unknown as { dataLayer: unknown[]; gtag: (...args: unknown[]) => void };
  w.dataLayer = w.dataLayer || [];
  w.gtag = (...args: unknown[]) => { w.dataLayer.push(args); };
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
  w.gtag('js', new Date());
  w.gtag('config', GA_ID);
}

export function readConsent(): CookieConsent | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as CookieConsent) : null;
  } catch {
    return null;
  }
}

export function applyConsent(consent: CookieConsent | null) {
  if (consent?.analytics) loadAnalytics();
}

export function saveConsent(choice: { analytics: boolean; marketing: boolean }): CookieConsent {
  const consent: CookieConsent = { necessary: true, ...choice, savedAt: new Date().toISOString(), version: 1 };
  try {
    localStorage.setItem(KEY, JSON.stringify(consent));
  } catch {
    /* storage blocked: the choice applies for this visit only */
  }
  applyConsent(consent);
  window.dispatchEvent(new Event(COOKIE_CONSENT_CHANGED_EVENT));
  return consent;
}
